/* eslint-disable */
import React, {useEffect, useMemo} from "react"
import {useCookies} from "react-cookie"
import {useTranslation} from "react-i18next"
import {makeStyles} from "@material-ui/core/styles"
import Box from "@material-ui/core/Box"
import {isIE} from "react-device-detect"
import {InformationPage, Switching} from "../pages"
import {useStore, useDispatch} from "../Store"
import {
  getCategoryList,
  getCategorySetList,
  getEquityList,
  getEquityForeignList,
  getEquitySetList,
  getFxList,
  getFxSetList,
  getBaseTrend,
  getSenarioBaseDateList,
} from "../api"
import "../i18n"
import {sleep, isAmOne, getTokenCookieName, getTokenCookie, getCookieOptions} from "../common"

const useStyles = makeStyles((theme) => ({
  root: {
    margin: `auto`,
  },
}))

export default function ContentEx({locale = `ja`}) {
  const classes = useStyles()
  const [cookies, setCookie] = useCookies([getTokenCookieName(), `milizeGuideDialog`])
  const {t, i18n} = useTranslation()
  const {dispatch} = useDispatch()
  const {
    store: {initialized, mainList, tabs, categoryList, mainType, mainGroup, mainCategory},
  } = useStore()

  const informationPage = useMemo(() => <InformationPage browser={`Internet Explorer`} />, [])
  const switching = useMemo(() => {
    console.log(`Initialized: `, initialized)
    const content = initialized ? <Switching /> : null
    return (
      <Box className={classes.root}>
        {content}
      </Box>
    )},
    [classes, initialized],
  )

  /**
   * ベーストレンド計上データを取得
   */
  const loadBaseTrendList = async () => {
    console.log(`loadBaseTrendList started.`)
    let list = await getBaseTrend(getTokenCookie(cookies))

    const trendList = list.map((trendData) => {
      const {label_ja, label_en, ...param} = trendData
      return {
        labelJa: label_ja,
        labelEn: label_en,
        ...param,
        similarity: 0.0,
      }
    })
    dispatch({
      type: `GET_BASE_TREND`,
      trendList,
    })
    console.log(`loadBaseTrendList done.`)
  }

  /**
   * プルダウン用データ辞書を作成
   */
  const makeList = (data) => data.map((obj) => {
    const {label_ja, label_en, ...param} = obj
    return {
      labelJa: label_ja,
      labelEn: label_en,
      ...param,
    }
  })

  /**
   * 株式銘柄リストを取得
   */
  const loadEquityList = async (tab) => {
    console.log(`loadEquityList (tab:${tab}) started.`)
    let data = await getEquityList(getTokenCookie(cookies), {
      group: mainGroup[tab],
    })
    
    mainList[tab] = makeList(data.list)
    console.log(`loadEquityList (tab:${tab}) done.`)
  }

  /**
   * 株式分類リストを取得
   */
  const loadEquityCategoryList = async (tab) => {
    console.log(`loadEquityCategoryList started.`)
    let data = await getCategoryList(getTokenCookie(cookies), {
      group: mainGroup[tab],
    })

    data.sort((a, b) => (a.value > b.value ? 1 : -1))
    categoryList[tab] = makeList(data)
    dispatch({
      type: `GET_CATEGORY_LIST`,
      categoryList,
    })
    console.log(`loadEquityCategoryList done.`)
  }

  const params = {
    region: `JP`,
    exchange: 200,
    type: 33,
    forward: true,
  }

  /**
   * 株式セット銘柄リストを取得
   */
  const loadEquitySetList = async (tab) => {
    console.log(`loadEquitySetList (tab:${tab}) started.`)
    let data = await getEquitySetList(getTokenCookie(cookies), {
      ...params,
      group: mainGroup[tab],
    })

    mainList[tab] = makeList(data.list)
    console.log(`loadEquitySetList (tab:${tab}) done.`)
  }

  /**
   * 株式セット分類リストを取得
   */
  const loadEquitySetCategoryList = async (tab) => {
    console.log(`loadEquitySetCategoryList (tab:${tab}) started.`)
    let data = await getCategoryList(getTokenCookie(cookies), {
      ...param,
      group: mainGroup[tab],
    })

    data.list.sort((a, b) => (a.value > b.value ? 1 : -1))
    categoryList[tab] = makeList(data.list)
    dispatch({
      type: `GET_CATEGORY_LIST`,
      categoryList,
    })
    console.log(`loadEquitySetCategoryList (tab:${tab}) done.`)
  }

  /**
   * FXセットリストを取得
   */
  const loadFxSetList = async (tab) => {
    console.log(`loadFxSetList (tab:${tab}) started.`)
    let data = await getFxSetList(getTokenCookie(cookies), {
      group: mainGroup[tab],
    })
    
    mainList[tab] = makeList(data.list)
    console.log(`loadFxSetList (tab:${tab}) done.`)
  }

  /** シナリオ基準日リストを取得 */
  const loadSenarioBaseDateList = async () => {
    console.log(`loadSenarioBaseDateList started.`)

    let data = await getSenarioBaseDateList(getTokenCookie(cookies))

    var grp = new Set()
    data.map((row) => { grp.add(row.group) })

    var value = {}
    Array.from(grp).map((g) => {
      var gl = {}
      data.map((r) => {
        if (r.group === g) gl[r.term] = r.baseDate
      })
      value[g] = gl
    })

    dispatch({
      type: `SENARIO_DATE_LIST`,
      value,
    })

    console.log(`loadSenarioBaseDateList done.`)
  }

  useEffect(() => {
    if (initialized)
      return

    const fetchData = async () => {
      // ロケール変更
      //await i18n.changeLanguage(locale)
      //ローディングダイアログ表示
      // (初期設定及び銘柄データ等取得時)
      const loadingModal = {
        title: t(`welcome.title`, {
          message1: t(`welcome.message`),
          message2: process.env.APP_NAME,
          joinArrays: ``,
        }),
        message: t(`loadingInitialData`),
        state: true,
      }
      dispatch({
        type: `LOADING_MODAL`,
        loadingModal,
      })

      let proms = []
      proms.push(loadBaseTrendList())

      Object.entries(tabs).map(([_, v]) => {
        switch (mainType[v]) {
          case `EQ`:
            proms.push(loadEquityList(v))
            proms.push(loadEquityCategoryList(v))
            break
          case `EQSET`:
            if (isAmOne()) {
              proms.push(loadSetEquityList(v))
              proms.push(loadEquitySetCategoryList(v))
            } else {
              proms.push(loadEquityList(v))
              proms.push(loadEquityCategoryList(v))
            }
            break
          case `FX`:
            proms.push(loadFxSetList(v))
            break
          case `FXSET`:
            proms.push(loadFxSetList(v))
            break
        }
      })
      await Promise.all(proms)

      console.log(`dispathcing loadData.`)
      dispatch({
        type: `MAIN_LIST`,
        mainList,
      })

      await loadSenarioBaseDateList()
    }

    const fetch = async () => {
      try {
        await fetchData()

        dispatch({
          type: `LOADING_MODAL`,
          loadingModal: {
            state: false,
          },
        })
        dispatch({
          type: `CONFIRM_DIALOG`,
          confirmDialog: {
            state: false,
          },
        })
        dispatch({
          type: `INITIALIZED`,
          value: true,
        })
        if (!(cookies?.milizeGuideDialog ?? null)) {
          dispatch({
            type: `GUIDE_DIALOG`,
            guideDialog: true,
          })
          setCookie(`milizeGuideDialog`, true, getCookieOptions())
        }
      } catch (error) {
        dispatch({
          type: `CONFIRM_DIALOG`,
          confirmDialog: {
            message: t(`error`),
            error,
            state: true,
          },
        })
      }
    }
    
    fetch()
  }, [])

  return isIE ? informationPage : switching
}
